<template>
  <b-container>
    <div class="notifications-page page w-100 p-0 m-0">
      <div class="page__header">
        <h2>My Notifications</h2>
      </div>
      <div class="page__card page__card--full page__card--no-bg mt-0">
        <notification-list />
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Notifications page
 * ==================================================================================
 **/

import NotificationList from '@/components/lists/NotificationList'

export default {
  metaInfo: function() {
    return {
      title: 'My Notifications'
    }
  },
  components: {
    NotificationList
  }
}
</script>
